import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { icons } from "../../../../../../utils/icons"
import { ModelDownloadButtons } from "../../../../../../components/donwloadFiles/model"
import { useStyles } from "./styles"
import { useTable } from "./hooks/table"
import { BaseMenu, CustomTable, SnackSimple } from "../../../../../../components"
import { Item } from "../../../../../../utils/types/generals"
import { OptionMenu } from "../../../../../calendar/pages/main/types"
import { useNavigate } from "react-router-dom"
import { useContext, useEffect, useState } from "react"
import { RequestErrors, Types } from "../../../../../../utils/enums"
import { FilesManagerContext } from "../../../../context"
import SimpleModal from "../../../../../../components/modal/simpleModal"
import { FiltersDrawer } from "../../../../../../components/filtersDrawer"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { returnQuery } from "../../../../../../utils/methods/returnQuery"
import { filesManagerServiceFetch } from "../../../../../../utils/constants/callService"
import { EditViewNavigate } from "../../../../utils/enums/menu"
import { LinearProgressDownload } from "../../../../../logbook/pages/main/components/shared/actionsTabs/linearProgressDownload"
import { formData } from "./constans/format"
import { handleAllErrors } from "../../../../../../utils/methods/handleErrors"




export const AllFiles = () => {

    const { t } = useTranslation()
    const styles = useStyles()
    const { selectedIds, isChecked, setSelectedIds, notFileSelected, setNotFileSelected, setIsChecked, filterFileMain, filterMainData, isLoading, typeDownload, uuid, getDetailInform } = useContext(FilesManagerContext)
    const { counter, errors, filterData, paginationModel, handlePagination, onChange, cleanFilter, sortTable, query } = filterFileMain
    const { input, getData } = filterMainData
    const { column, row, detail, setDetail, tableLoading, totalPages, downloadCustomeExcel, downloadCustomePdf, downloadCustomeWord, getFilesList } = useTable({ setIsChecked, selectedIds, setSelectedIds, isChecked, notFileSelected, setNotFileSelected, filterFileMain, getDetailInform, uuid })
    const navigate = useNavigate()
    const [isLoadingDelete, setIsLoadingDelete] = useState(false)

    const [snackbarOpen, setSnackbarOpen] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })

    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void
    }>({
        open: false,
        title: t('filesManager.modal.titles.confirmation'),
        description: '',
        confirm: () => { },
    })

    const closeMenu = () => {
        setDetail((prev) => ({
            ...prev,
            anchor: null,
        }))
    }

    const closeSnackBarOpen = () => {
        setSnackbarOpen(prev => ({ ...prev, open: false }))
    }

    const handleOpenModalDelete = () => {
        if (selectedIds.length === 0 && !isChecked) {
            setSnackbarOpen(prev => ({
                ...prev,
                open: true,
                message: t('filesManager.snackbar.selectAtLeastOneFile'),
                type: Types.ERROR
            }))
        } else {
            setModal(prev => ({
                ...prev,
                open: true,
                description: t('filesManager.modal.description.areYouSureWantDeleteAllFilesSelected', { count: selectedIds.length }),
                confirm: () => { handleDeleteMasive() },
            }))
        }
    }
    const closeModalDelete = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    const handleDeleteUnique = async () => {
        setIsLoadingDelete(true)

        const response = await filesManagerServiceFetch.deleteFile(Number(detail.id));

        if (response.code == '00') {
            setSnackbarOpen(prev => ({ ...prev, open: true, message: t('filesManager.snackbar.delete.success.unique'), type: Types.SUCCESS }))
            setSelectedIds([]);
            setNotFileSelected([]);
            setIsChecked(false)
            getFilesList()
        } else {
            setSnackbarOpen(prev => ({ ...prev, open: true, message: handleAllErrors(response?.code as RequestErrors, t), type: Types.ERROR }))
        }

        setIsLoadingDelete(false)
        closeModalDelete()
    }

    const handleDeleteMasive = async () => {
        setIsLoadingDelete(true)

        const payload = {
            all: isChecked,
            file_ids: isChecked ? [] : selectedIds,
            not_file_ids: isChecked ? notFileSelected : []
        };
        const response = await filesManagerServiceFetch.deleteFilesMasive(payload, isChecked ? returnQuery({ ...filterFileMain.query, filter: filterFileMain.query.filter?.replaceAll('+', '%2B') }, formData) : undefined);

        if (response.code == '00') {
            setSnackbarOpen(prev => ({ ...prev, open: true, message: t('filesManager.snackbar.delete.success.masive'), type: Types.SUCCESS }))
            setSelectedIds([]);
            setNotFileSelected([]);
            setIsChecked(false)
            getFilesList()
        } else {
            setSnackbarOpen(prev => ({ ...prev, open: true, message: handleAllErrors(response?.code as RequestErrors, t), type: Types.ERROR }))
        }

        setIsLoadingDelete(false)
        closeModalDelete()
    }

    const handleEnableDisable = async (activate: boolean) => {
        const response = await filesManagerServiceFetch.enableOrDisableFile({ id: Number(detail.id) });
        getFilesList();
        setSnackbarOpen(prev => ({
            ...prev,
            open: true,
            message: t(`filesManager.snackbar.${activate ? 'activateFile' : 'desactivateFile'}`),
            type: Types.SUCCESS
        }))
    }

    const optionMenu: OptionMenu = ({ item, type }) => {
        const menu: { [x: string]: () => void } = {
            '1': () => {
                navigate(`../detail/${detail.id}`);
            },
            '2': () => {
                handleEnableDisable(true)
            },
            '3': () => {
                handleEnableDisable(false)
            },
            '4': () => {
                navigate(`../edit/${detail.id}`, { state: { option: EditViewNavigate.TABLE } });
            },
            '5': () => {
                setModal(prev => ({
                    ...prev,
                    open: true,
                    description: t('filesManager.modal.description.areYouSureWantDeleteThisFileSelected'),
                    confirm: () => { handleDeleteUnique() },
                }))
            },
        }

        menu[item?.value]?.()
    }

    useEffect(() => {
        getData()
    }, [])


    return (
        <Box sx={{ minHeight: '70vh' }}>
            <FiltersDrawer cleanFilter={cleanFilter} count={counter} right={0} top={90}>
                <Box sx={styles.section}>
                    <DinamicForm errors={errors} input={Object.values(input)} values={filterData} onChange={onChange} filter={true} legacyErrors />
                </Box>
            </FiltersDrawer>

            <Box sx={styles.header}>
                <Typography variant="title_grey_big">{t('filesManager.titles.fileRepository')}</Typography>

                <Box sx={styles.flex}>

                    {(selectedIds.length !== 0 || isChecked) &&
                        <Button
                            variant='text_primary'
                            color="primary"
                            onClick={() => {
                                navigate(`/dashboard/filesManager/massivePermission`);
                            }}>
                            {t('filesManager.buttons.masivePermission')}
                        </Button>
                    }

                    <LinearProgressDownload show={isLoading} text={t(`filesManager.snackbar.generateFilesDownload_${typeDownload}`)} />

                    <Button variant="outlined" color="primary" onClick={handleOpenModalDelete}>
                        {t('filesManager.buttons.delete')}
                    </Button>

                    <ModelDownloadButtons
                        csv={downloadCustomeExcel}
                        pdf={downloadCustomePdf}
                        word={downloadCustomeWord}
                        disableCSV={isLoading}
                        disablePDF={isLoading}
                        disableWORD={isLoading}
                        customeLabels={{
                            csv: t('filesManager.buttons.csvFiles'),
                            pdf: t('filesManager.buttons.pdfFiles'),
                            word: t('filesManager.buttons.wordFiles')
                        }}
                        styleType
                    />

                    <Tooltip title={t('ToolTips.create')}>
                        <IconButton
                            sx={styles.clean}
                            onClick={() => {
                                navigate(`/dashboard/filesManager/create`);
                            }}
                        >
                            {icons('add')}
                        </IconButton>
                    </Tooltip>

                    {!!counter && <IconButton
                        sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                        onClick={() => {
                            cleanFilter()
                        }}
                    >
                        {icons('clean')}
                    </IconButton>
                    }
                </Box>
            </Box>

            <CustomTable
                name="Informe General"
                serverSidePagination={{ page: paginationModel.page + 1, size: paginationModel.pageSize, totalPages: totalPages }}
                handleChange={(page: number, pageSize: number) => {
                    handlePagination({ page, pageSize })
                }}
                order={
                    query?.sort && {
                        count: query?.sort?.count,
                        key: query?.sort?.field,
                        order: query?.sort?.sort,
                    }
                }
                sortable={(field, sort, count) => {
                    sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
                }}
                column={column}
                loader={tableLoading}
                row={row}
                selected={-1}
            />

            <BaseMenu
                sx={[styles.baseMenu, detail.positionMenu]}
                anchorEl={detail.anchor}
                setAnchorEl={closeMenu}
                menuItems={detail.menu}
                click={(item) => {
                    optionMenu({ item: item as Item })
                }}
            />

            <SnackSimple open={snackbarOpen.open} close={closeSnackBarOpen} message={snackbarOpen.message} type={snackbarOpen.type} />

            <SimpleModal
                open={!!modal.open}
                next={modal.confirm}
                back={closeModalDelete}
                close={closeModalDelete}
                description={modal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                title={modal.title}
                loadingButton
                isLoading={isLoadingDelete}
            />

        </Box>
    )
}